import Vue from 'vue'
import config from './../config'

const app = new Vue()

app.install = function (Vue) {

  Vue.filter('articleUrl', function (product, view = '') {
    return config.appUrl + '/article/' + product.key + '/' + view
  })

  Vue.filter('categoryUrl', function (category, view = '') {
    return config.appUrl + '/companies/' + category.slug + '/' + view
  })

}

export default app



// WEBPACK FOOTER //
// ./client/filters/app.js